import React, { useState, useEffect } from 'react';
import { Chip, List, ListItem, Grid, Cell } from 'react-md';
import BlackArrow from "../../images/png/right-arrow.png";
import MathJax from "../../components/react-mathjax-preview";
import { NotificationManager } from 'react-notifications';
import { Menu, MenuItem, MenuButton, MenuHeader, MenuDivider, SubMenu, ControlledMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid as RG, Typography, Tooltip, IconButton  } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { RxEnterFullScreen } from "react-icons/rx";
import { CgMinimize } from "react-icons/cg";
import { ImArrowUp, ImArrowDown } from "react-icons/im";




const AnswerTypeReasoningChain = (props) => {

    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [reasoningElements, setReasoningElements] = useState([]);
    const [connectingWords, setConnectingWords] = useState([]);
    const [conclusionSentences, setConclusionSentences] = useState([]);
    const [customTextsArr, setCustomTextsArr] = useState([]);
    const [customTextStr, setCustomTextStr] = useState("");
    const [showCustomTextDialog, setShowCustomTextDialog] = useState(false);
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [maxCount, setMaxCount] = useState(3);

    const [reasoningSpaceFormat, setReasoningSpaceFormat] = useState("");


    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.hideQuestion) {
            setMaxCount(7);
        } else if (props.hideNavAndCat) {
            setMaxCount(7);
        } else {
            setMaxCount(5);
        }
    }, [props.hideQuestion, props.hideNavAndCat])

    useEffect(() => {
        console.debug("props.conclusionSentences", props)
        if (props.reasoningElements) {
            let data = props.reasoningElements.map(ele => {
                return { ...ele, show: true }
            })
            setReasoningElements(data)
        }
        if (props.connectingWords) {
            setConnectingWords(props.connectingWords.map(ele => {
                return { ...ele, show: true }
            }))
        }
        if (props.conclusionSentences) {
            setConclusionSentences(props.conclusionSentences.map(ele => {
                return { ...ele, show: true }
            }))
        }
        setCustomTextsArr([]);
        setCustomTextStr("");

        setItems([]);
        setCategories([]);

    }, [props.questionID, props.count]);


    useEffect(() => {
        let spaceFormat = "";
        if (items && items.length) {
            let length = items.length;
            console.debug("items>>>", items)
            items.forEach((ele, index) => {
                if (index === length - 1) {
                    if (ele.code.includes("T")) {
                        spaceFormat += `[${ele.text}]`
                    } else {
                        spaceFormat += ele.code
                    }

                } else {
                    if (ele.code.includes("T")) {
                        spaceFormat += `[${ele.text}]-`
                    } else {
                        spaceFormat += `${ele.code}-`
                    }

                }

            })
        }

        console.debug("spaceFormat>>>", spaceFormat, items)

        setReasoningSpaceFormat(spaceFormat);
        props.onReasoningChainFormatChange(spaceFormat);

    }, [items])

    useEffect(() => {
        if (reasoningSpaceFormat) {
            props.addActivityLog(reasoningSpaceFormat);
        }
    }, [reasoningSpaceFormat])

    const handleAddElement = (type, code, text, index) => {
        let newCategories = [...categories];
        let newItems = [...items];

        // Check if a new category needs to be created
        if (categories.length === 0 || (items.length >= maxCount * categories.length)) {
            let newCat = {
                id: categories.length + 1,
                name: `Category ${categories.length + 1}`
            };
            newCategories.push(newCat);
        }

        setCategories(newCategories);

        // Calculate the category ID for the new item
        const categoryId = Math.floor(items.length / maxCount) + 1;

        let newItem = {
            id: items.length + 1,
            code,
            text,
            index: items.length,
            category: categoryId
        };

        newItems.push(newItem);
        setItems(newItems);

        // remove the index from respective tabs
        if (type === "R") {
            let updatedReasoningElements = [...reasoningElements];
            console.debug("updatedReasoningElements", updatedReasoningElements, index)
            updatedReasoningElements[index].show = false;
            setReasoningElements(updatedReasoningElements);
        } else if (type === "J") {
            //same connecting words can be used in multiple places so always show it
            // let updatedConnectingWords = [...connectingWords];
            // updatedConnectingWords[index].show = false;
            // setConnectingWords(updatedConnectingWords);
        } else if (type === "C") {
            let updatedConclusionWords = [...conclusionSentences];
            updatedConclusionWords[index].show = false;
            setConclusionSentences(updatedConclusionWords);
        } else if (type === "T") {
            let updatedCustomTextArr = [...customTextsArr];
            updatedCustomTextArr[index].show = false;
            setCustomTextsArr(updatedCustomTextArr);
        }
    }

    const handleRemoveElementFromSpace = (element, itemIndex) => {

        let newItems = [...items];
        newItems.splice(itemIndex, 1)

        // Update the indices and categories of the remaining items
        newItems = newItems.map((item, index) => ({
            ...item,
            id: index + 1,
            index: index,
            category: Math.floor(index / maxCount) + 1
        }));

        // Update categories if necessary
        let newCategories = categories.filter(cat => {
            return newItems.some(item => item.category === cat.id);
        });

        setItems(newItems);
        setCategories(newCategories);

        console.debug("newItems and newCategories", newItems, newCategories)
        if (element.code.includes("R")) {
            let newREArr = [...reasoningElements];
            let index = newREArr.findIndex(re => re.code === element.code);
            newREArr[index].show = true;
            console.debug("reasoningElements", reasoningElements, element)
            setReasoningElements(newREArr)
        } else if (element.code.includes("J")) {
            let newConnArr = [...connectingWords];
            let index = newConnArr.findIndex(re => re.code === element.code);
            newConnArr[index].show = true;
            setConnectingWords(newConnArr);
        } else if (element.code.includes("C")) {
            let newCluArr = [...conclusionSentences];
            let index = newCluArr.findIndex(re => re.code === element.code);
            newCluArr[index].show = true;
            setConclusionSentences(newCluArr)
        }

    }

    const handleUpArrowClick = (index) => {
        console.debug("UP index", index)
        if (index === 0) return;

        let newItems = [...items];
        [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];

        let count = 0;
        let catID = 1;
        newItems = newItems.map((item, index) => {
            if (count !== 0 && count % maxCount === 0) {
                catID++;
            }
            count++;

            return {
                ...item,
                index: index,
                category: catID,
            }
        })


        let newCategories = categories.filter(cat => {
            return newItems.some(item => item.category === cat.id);
        });

        setCategories(newCategories);

        setItems(newItems);
    }

    const handleDownArrowClick = (index) => {
        if (index === items.length - 1) return;

        let newItems = [...items];
        [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];

        let count = 0;
        let catID = 1;
        newItems = newItems.map((item, index) => {
            if (count !== 0 && count % maxCount === 0) {
                catID++;
            }
            count++;

            return {
                ...item,
                index: index,
                category: catID,
            }
        })

        let newCategories = categories.filter(cat => {
            return newItems.some(item => item.category === cat.id);
        });

        setCategories(newCategories);

        setItems(newItems);
    }


    const handleAddCustomText = () => {
        if (customTextStr === "") {
            NotificationManager.warning("Please enter your custom text", 'Empty Custom Text', 3000)
            return;
        }

        let updatedCustomTextArr = [...customTextsArr];
        let index = updatedCustomTextArr.length;

        let newCustomText = {
            code: `T${updatedCustomTextArr.length}`,
            text: customTextStr,
        }
        updatedCustomTextArr.push(newCustomText);

        setCustomTextsArr(updatedCustomTextArr);

        let updatedItems = [...items];
        const categoryId = Math.floor(items.length / maxCount) + 1;
        updatedItems.push({
            code: `T${index}`,
            text: customTextStr,
            index: index,
            category: categoryId,
            id: items.length + 1,
        });
        setItems(updatedItems);
        setShowCustomTextDialog(false);
        setCustomTextStr("");

    }

    const onDragEnd = (result) => {
        const { source, destination, draggableId } = result;

        if (!destination) {
            return;
        }

        console.debug("result", result);

        let newItems = [...items];

        if (destination.droppableId !== source.droppableId) {
            newItems = items.map((item) => {
                console.debug("item.id", item.id, draggableId)
                if (item.id === parseInt(draggableId)) {
                    return {
                        ...item,
                        category: parseInt(destination.droppableId),
                    }
                }
                return item
            });

            // Rearrange items in the new category
            let catItems = newItems.filter(item => item.category === parseInt(destination.droppableId));
            let nonItems = newItems.filter(item => item.category !== parseInt(destination.droppableId));

            // if (destination.index !== source.index) {
            const movedItemIndex = catItems.findIndex(item => item.id === parseInt(draggableId));
            const newCatItems = rearrangeArrOne(catItems, movedItemIndex, destination.index);
            newItems = [
                ...newCatItems,
                ...nonItems
            ];
            // }

        } else if (destination.index !== source.index) {
            let catItems = items.filter(item => item.category === parseInt(destination.droppableId))
            let nonItems = items.filter(item => item.category !== parseInt(destination.droppableId))
            const newCatItems = rearrangeArrTwo(catItems, source.index, destination.index);
            console.debug("catItems, nonItems, newCatItems", catItems, nonItems, newCatItems, source.index, destination.index)
            newItems = [
                ...newCatItems,
                ...nonItems
            ]
        }

        newItems.sort((a, b) => a.category - b.category)

        newItems = newItems.map((item, index) => {
            return {
                ...item,
                index: index,
                id: index + 1,
            }
        })

        // Update the indices and categories of the remaining items
        newItems = newItems.map((item, index) => ({
            ...item,
            category: Math.floor(index / maxCount) + 1
        }));

        // Update categories if necessary
        let newCategories = categories.filter(cat => {
            return newItems.some(item => item.category === cat.id);
        });


        setItems(newItems);
        setCategories(newCategories);

    };


    const rearrangeArrTwo = (arr, sourceIndex, destIndex) => {
        let arrCopy = [...arr];

        let indexOne = arr.findIndex(item => item.index === sourceIndex);
        let indexTwo = arr.findIndex(item => item.index === destIndex);

        const tempIndex = arrCopy[indexOne].index;
        arrCopy[indexOne].index = arrCopy[indexTwo].index;
        arrCopy[indexTwo].index = tempIndex;

        arrCopy.sort((a, b) => a.index - b.index)

        return arrCopy;
    };


    const rearrangeArrOne = (arr, sourceIndex, destIndex) => {
        const arrCopy = [...arr];
        const [removed] = arrCopy.splice(sourceIndex, 1);
        arrCopy.splice(destIndex, 0, removed);
        return arrCopy;
    };

    return (
        <div className='answer-reasoning-chain w-100' style={{
            height: props.hideQuestion ? "calc(100% - 42px)" : "calc(100% - 22px)",
            transform: 'height 0.6s ease',
        }}>
            <Grid className='h-100 w-100 position-relative' style={{
                flexDirection:'row-reverse',
            }}>

                <Cell size={props.hideQuestion ? 6 : 12} className='position-relative answer-reasoning-space-container' style={{
                    // minHeight:'200px',
                    height: props.hideQuestion ? '100%' : '100%',
                    transform: 'height 0.6s ease',
                }}>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <div className='answer-reasoning-space' style={{
                            height: props.hideQuestion ? "100%" : '100%'
                        }}>
                            <div className='d-flex justify-content-start mb-2' style={{ gap: '1rem' }}>
                                <Typography fontSize={14} fontWeight={'500'}>Reasoning Space</Typography>
                                <Menu
                                    position='initial'
                                    direction={'right'}
                                    menuButton={
                                        <button className='add-rc-btn'>
                                            {/* <FiPlusCircle color='#444' />  */}
                                            Add
                                        </button>
                                    } className="rc-add-menu">
                                    <SubMenu
                                        // position='initial'
                                        label="Reasoning Elements" menuStyle={{ width: '400px', maxHeight: '300px', overflowY: 'auto' }}>
                                        <MenuHeader>
                                            Reasoning Elements
                                        </MenuHeader>
                                        {reasoningElements?.map((ele, index) => {
                                            if (ele.show) {
                                                return <>
                                                    <MenuItem key={index} onClick={() => {
                                                        handleAddElement("R", ele.code, ele.element, index)
                                                    }}>
                                                        <MathJax className="re-mathjax-text" math={ele.element} />
                                                    </MenuItem>
                                                    {index !== reasoningElements?.length - 1 ?
                                                        <MenuDivider />
                                                        : null}
                                                </>
                                            }

                                        })}
                                    </SubMenu>
                                    <SubMenu label="Connecting Words" menuStyle={{ width: '300px', maxHeight: '300px', overflowY: 'auto' }}>
                                        <MenuHeader>Connecting Words</MenuHeader>
                                        {connectingWords?.map((ele, index) => {
                                            if (ele.show) {
                                                return <>
                                                    <MenuItem
                                                        key={index}
                                                        onClick={() => {
                                                            handleAddElement("J", ele.code, ele.word, index)
                                                        }}
                                                    >{ele.word}</MenuItem>
                                                    {index !== connectingWords?.length - 1 ?
                                                        <MenuDivider />
                                                        : null}
                                                </>
                                            }
                                        })}
                                    </SubMenu>
                                    <SubMenu label="Conclusions" menuStyle={{ width: '300px', maxHeight: '300px', overflowY: 'auto' }}>
                                        <MenuHeader>Conclusions</MenuHeader>
                                        {conclusionSentences?.map((ele, index) => {
                                            if (ele.show) {
                                                return <>
                                                    <MenuItem
                                                        key={index}
                                                        onClick={() => {
                                                            handleAddElement("C", ele.code, ele.sentence, index)
                                                        }}
                                                    >
                                                        <div className='py-2 d-flex w-100 justify-content-start align-items-center'>
                                                            <MathJax className="re-mathjax-text" math={ele.sentence} />
                                                        </div>
                                                    </MenuItem>
                                                    {index !== conclusionSentences?.length - 1 ?
                                                        <MenuDivider />
                                                        : null}
                                                </>


                                            }
                                        })}
                                    </SubMenu>
                                </Menu>
                            </div>

                            <div className='d-flex justify-content-start' style={{ gap: '12px' }}>
                                {categories.map((category, index) => (

                                    <Droppable droppableId={category.id.toString()}>
                                        {(provided) => (
                                            <div ref={provided.innerRef} >
                                                {items
                                                    .filter(
                                                        (item) => item.category === category.id
                                                    )
                                                    .map(item => (
                                                        <Draggable
                                                            draggableId={item.id.toString()}
                                                            key={item.id}
                                                            index={item.index}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className='mb-2'
                                                                >
                                                                    <Element
                                                                        ele={item}
                                                                        itemIndex={item.index}
                                                                        handleUpArrowClick={handleUpArrowClick}
                                                                        handleDownArrowClick={handleDownArrowClick}
                                                                        handleRemoveElementFromSpace={handleRemoveElementFromSpace}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                ))}
                            </div>
                        </div>
                    </DragDropContext>

                </Cell>

                <Cell size={props.hideQuestion ? 6 : 12} className={`reasoning-chain-tabcontainer 
                    ${props.hideQuestion ? "" : "reasoning-chain-tabcontainer2"}
                `} style={{
                    height: props.hideQuestion ? '100%' : '45%',
                    transform: 'height 0.6s ease',
                }}>
                    <div className='rc-expand'>
                        <Tooltip placement="top" arrow title={props.hideQuestion ? "Minimize" : "Expand"}>
                            <IconButton size='small' color="primary" onClick={props.handleHideQuestion}>
                                {props.hideQuestion ? <CgMinimize fontSize={20} /> : <RxEnterFullScreen fontSize={20} />}
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className='rc-tab-headers'>
                        <button className={`${selectedTabIndex === 0 ? "active" : ""}`}
                            onClick={() => setSelectedTabIndex(0)}
                        >
                            Reasoning Elements
                        </button>
                        <button className={`${selectedTabIndex === 1 ? "active" : ""}`}
                            onClick={() => setSelectedTabIndex(1)}
                        >
                            Connecting Words
                        </button>
                        <button className={`${selectedTabIndex === 2 ? "active" : ""}`}
                            onClick={() => setSelectedTabIndex(2)}
                        >
                            Conclusions
                        </button>
                        <button className={`${selectedTabIndex === 3 ? "active" : ""}`}
                            onClick={() => setSelectedTabIndex(3)}
                        >
                            Custom Texts
                        </button>
                    </div>

                    <div className='rc-container'>
                        {selectedTabIndex === 0 ?
                            <List className="w-100 reasoning-chain-list ">
                                {reasoningElements?.map((ele, index) => {
                                    if (ele.show)
                                        return (
                                            <ListItem
                                                key={index}
                                                style={{ width: '100%', }}
                                                onClick={() => {
                                                    handleAddElement("R", ele.code, ele.element, index)
                                                }}
                                            >
                                                <div className='py-2 d-flex h-100 w-100 justify-content-start align-items-end
                                            '>
                                                    <div className='w-100 h-100'>
                                                        <MathJax className="re-mathjax-text" math={ele.element} />
                                                    </div>
                                                    {props.showReasoningElementCategoryInfo ?
                                                        <div className='rc-cat-chip'>{ele.category}</div>
                                                        : null}
                                                </div>
                                            </ListItem>
                                        );
                                })}
                            </List>
                            : null}

                        {selectedTabIndex === 1 ?
                            <div className='mt-3'>
                                {connectingWords?.map((ele, index) => {
                                    if (ele.show) {
                                        return (
                                            <Chip
                                                co
                                                key={index}
                                                className='mx-1'
                                                label={ele.word}
                                                onClick={() => {
                                                    handleAddElement("J", ele.code, ele.word, index)
                                                }}
                                            />
                                        )
                                    }
                                })}
                            </div>
                            : null}

                        {selectedTabIndex === 2 ?
                            <List className="w-100 reasoning-chain-list ">
                                {conclusionSentences?.map((ele, index) => {
                                    if (ele.show)
                                        return (
                                            <ListItem
                                                key={index}
                                                onClick={() => {
                                                    handleAddElement("C", ele.code, ele.sentence, index)
                                                }}
                                            >
                                                <div className='py-2 d-flex w-100 justify-content-start align-items-center'>
                                                    <MathJax className="re-mathjax-text" math={ele.sentence} />
                                                </div>
                                            </ListItem>
                                        )
                                })}
                            </List>
                            : null}

                        {selectedTabIndex === 3 ?
                            <div>
                                <div className='d-flex justify-content-end '>
                                    {/* Custom text */}
                                    <button className='custom-text-btn' onClick={() => setShowCustomTextDialog(true)}>
                                        Add Custom Text
                                    </button>
                                </div>
                                <List className="w-100 reasoning-chain-list ">
                                    {customTextsArr && customTextsArr.length ? customTextsArr?.map((ele, index) => {
                                        // if (ele.show)
                                        return (
                                            <ListItem
                                                key={index}
                                                onClick={() => {
                                                    handleAddElement("T", ele.code, ele.text, index)
                                                }}
                                            >
                                                <div className='py-2 d-flex w-100 justify-content-start align-items-center'>
                                                    <MathJax className="re-mathjax-text" math={ele.text} />
                                                </div>
                                            </ListItem>
                                        )
                                    }) : <div className='text-align-center fontClass-20 mt-5'>
                                        No Custom Texts
                                    </div>}
                                </List>
                            </div>

                            : null}
                    </div>

                </Cell>
            </Grid>

            {/* Custom text dialog */}
            <Dialog open={showCustomTextDialog} fullWidth maxWidth='sm'>
                <DialogTitle>Add Custom Text</DialogTitle>
                <DialogContent>
                    <div className='w-100'>

                        <textarea
                            style={{
                                border: "1px solid #d2d2d6",
                                borderRadius: '6px',
                            }}
                            onChange={(e) => {
                                let text = e.target.value;
                                setCustomTextStr(text);
                            }}
                            rows={4}
                            className='w-100 p-2 fontClass-14'
                            placeholder='Enter your custom text' />

                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={handleAddCustomText}>Add</Button>
                    <Button variant='outlined' onClick={() => setShowCustomTextDialog(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>
            {/* <DialogContainer
                id="custom-text-dialog"
                visible={showCustomTextDialog}
                title="Add Custom Text"
                focusOnMount={false}
                onHide={() => setShowCustomTextDialog(false)}
                closeOnEsc
            >
                <div className='w-100'>
                    
                    <textarea
                        style={{
                            border:"1px solid #d2d2d6",
                            borderRadius:'6px',
                        }}
                        onChange={(e) => {
                            let text = e.target.value;
                            setCustomTextStr(text);
                        }}
                        rows={4}
                        className='w-100 p-2 fontClass-14'
                        placeholder='Enter your custom text' />

                </div>

                <div className='d-flex justify-content-end mt-3' style={{ gap: "4px" }}>
                    <Button size="sm" raised primary onClick={handleAddCustomText}>Add</Button>
                    <Button flat primary onClick={() => setShowCustomTextDialog(false)}>Cancel</Button>
                </div>

            </DialogContainer> */}
        </div>
    );
}

const Element = ({ ele, itemIndex, handleUpArrowClick, handleDownArrowClick, handleRemoveElementFromSpace }) => {
    return (

        <div className='rs-card'>
            <div className='rs-no'>{ele.id}</div>
            <div className='rs-text'>
                <MathJax className="re-mathjax-text" math={ele.text} />
            </div>
            <div className='answer-reasoning-space-card-arrows' style={{ position: 'relative' }}>
                <button className='up-arrow' onClick={() => {
                    handleUpArrowClick(itemIndex)
                }}>
                    {/* <img src={BlackArrow} width={20} style={{ filter: "grayscale(100%)" }} alt='Up Arrow Icon' /> */}
                    <ImArrowUp color='gray'  />
                </button>
                <button className='down-arrow' onClick={() => {
                    handleDownArrowClick(itemIndex)
                }}>
                    {/* <img src={BlackArrow} style={{ filter: "grayscale(100%)" }} alt='Down Arrow Icon' /> */}
                    <ImArrowDown color='gray' />
                </button>
                <button className='answer-reasoning-space-card-remove' onClick={() => {
                    handleRemoveElementFromSpace(ele, itemIndex);
                }}>x</button>
            </div>
        </div>

    )
}

export default AnswerTypeReasoningChain;
